import { Component, ElementRef, HostListener, Input, OnDestroy, ViewChild } from '@angular/core';
import { LoggerService } from 'src/app/services/logger/logger.service';
import tippy, { Instance } from 'tippy.js';

type PaymentType = Record<
  'REGULAR' | 'ONETIME',
  {
    desc: string;
    explain: string;
    paymentInfo: string;
  }
>;

@Component({
  selector: 'libero-entry-fee-calc-item',
  templateUrl: './entry-fee-calc-item.component.html',
  styleUrls: ['./entry-fee-calc-item.component.scss'],
  standalone: false,
})
export class EntryFeeCalcItemComponent implements OnDestroy {
  @Input() public feeIncludingVat = 0;
  @Input() public feeVat = 0;
  @Input() public feeRatio = 0;
  @Input() public discountRegularDeposit = 0;
  @Input() public currencyCode = 'CZK'
  @Input() public type: 'REGULAR' | 'ONETIME' | null = null;
  @Input() public useStrategyStyling = false;

  @ViewChild('explainTooltipContent', { static: false }) private popoverContent?: ElementRef;
  private tippyInstance: null | Instance  = null;

  private triggerButton?: Element;
  @ViewChild('explainTooltipButton') public set content(content: ElementRef) {
    if(content?.nativeElement) {
      this.triggerButton = content.nativeElement;
      this.bindTooltip();
    }
  }
  @HostListener('window:scroll')
  private onScroll() {
    if (this.tippyInstance && this.tippyInstance.state.isVisible) {
      this.tippyInstance.hide();
    }
  }


  public typeKeys: PaymentType = {
    'REGULAR': {
      desc: 'regularPayments',
      explain: 'fee2_regular',
      paymentInfo: 'paymentInfo_regular',
    },
    'ONETIME': {
      desc: 'onetimePayments',
      explain: 'fee2_onetime',
      paymentInfo: 'paymentInfo_onetime',
    }
  }

  public constructor(
    private loggerService: LoggerService,
  ) {}

  private bindTooltip(): void {
    if(this.triggerButton &&
      this.popoverContent &&
      this.popoverContent.nativeElement
    ) {
      this.destroyTooltipInstance();

      this.tippyInstance = tippy(this.triggerButton, {
        content: this.popoverContent.nativeElement.innerHTML,
        allowHTML: true,
        placement: 'auto',
      }) as Instance; // never return array if input is single Element
    }
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll);
    this.destroyTooltipInstance();
  }

  private destroyTooltipInstance(): void {
    if(this.tippyInstance) {
      try {
        this.tippyInstance.destroy();
        this.tippyInstance = null;
      } catch (error) {
        this.loggerService.error(error);
      }
    }
  }
}
